export default __webpack_public_path__ + "maps-examples-multiple-images-thumbnail-480-05580da0297dee80741a4d8372f3f2a1.png";